import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedEnterpriseId: null,
  selectedGameRunId: null,
  selectedGroupId: null, // Keep for backward compatibility
  selectedGroupIds: [], // For multi-group selection
};

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setSelectedEnterprise: (state, action) => {
      state.selectedEnterpriseId = action.payload;
      // Reset game run and group when enterprise changes
      state.selectedGameRunId = null;
      state.selectedGroupId = null;
    },
    setSelectedGameRun: (state, action) => {
      state.selectedGameRunId = action.payload;
      // Reset groups when game run changes
      state.selectedGroupId = null;
      state.selectedGroupIds = [];
    },
    setSelectedGroup: (state, action) => {
      state.selectedGroupId = action.payload;
    },
    setSelectedGroupIds: (state, action) => {
      state.selectedGroupIds = action.payload;
    },
    toggleGroupSelection: (state, action) => {
      const groupId = action.payload;
      if (state.selectedGroupIds.includes(groupId)) {
        state.selectedGroupIds = state.selectedGroupIds.filter(id => id !== groupId);
      } else {
        state.selectedGroupIds = [...state.selectedGroupIds, groupId];
      }
    },
    clearAdminSelection: (state) => {
      state.selectedEnterpriseId = null;
      state.selectedGameRunId = null;
      state.selectedGroupId = null;
      state.selectedGroupIds = [];
    },
  },
});

export const {
  setSelectedEnterprise,
  setSelectedGameRun,
  setSelectedGroup,
  setSelectedGroupIds,
  toggleGroupSelection,
  clearAdminSelection
} = adminSlice.actions;

export const selectSelectedEnterpriseId = (state) => state.admin.selectedEnterpriseId;
export const selectSelectedGameRunId = (state) => state.admin.selectedGameRunId;
export const selectSelectedGroupId = (state) => state.admin.selectedGroupId;
export const selectSelectedGroupIds = (state) => state.admin.selectedGroupIds;

export default adminSlice.reducer;
